import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		// 视图模式：true 为移动端，false 为 PC 端（760px 为断点）
		isMobile: window.innerWidth <= 760
	},
	mutations: {
		SET_IS_MOBILE(state, isMobile) {
			state.isMobile = isMobile;
		}
	},
	actions: {},
	modules: {}
});
